<template>
  <el-container style="width: 100%;height: 100%;display: flex;flex-direction: column;">
    <el-row style="width: 100%; height: 48px;margin-bottom: 1px;background-color: #ffffff;">
      <el-menu default-active="1" class="horizontal-menu" @select="menuSelect"
               mode="horizontal" unique-opened background-color="rgba(0, 0, 0, 0)" text-color="rgba(0, 0, 0, 1)">
        <template v-for="sub in energyItem">
          <el-menu-item class="horizontal-menu-item" :key="sub.id" :index="sub.id">
            <span style="font-size: 14px;">{{sub.name}}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </el-row>
    <el-row style="width: 100%;height: calc(100% - 49px);display: flex;flex-direction: row;">
      <el-aside style="height: 100%;width: 250px;margin-right: 1px;background-color: #ffffff;">
        <el-row class="doc-tree-top">
          <el-input style='width: 100%; border: none; outline: none' class="filter-search" placeholder="输入关键字搜索" prefix-icon="zy-icon-search" v-model="filterName"/>
        </el-row>
        <el-tree :data="treeData" :props="defaultProps" @node-click="handleNodeClick" node-key='id' :filter-node-method="filterNode"
                 :default-expanded-keys="expandKeys" highlight-current ref="tree" class="aside-tree">
        <span slot-scope="{ node, data }">
          <i v-if="node.data.type === '1'" class="zy-icon-building"></i>
          <i v-if="node.data.type === '2'" class="zy-icon-commit"></i>
          <i v-if="node.data.type === '3'" class="zy-icon-sensor"></i>
          <span>{{ node.label }}</span>
        </span>
        </el-tree>
      </el-aside>
      <el-main style="overflow-y: hidden;font-size: 14px;width: calc(100% - 251px);height: 100%;background-color: #ffffff;">
        <el-row class="tt-input" style="width: 100%;height: 48px;line-height: 48px;color: rgb(127, 127, 127);text-align: left;">
          <span style="margin-left: 24px;">时间：</span>
          <el-date-picker v-model="startDate" style="width: 140px;margin-left: 16px" type="date"
                          placeholder="选择日期" value-format="yyyy-MM-dd" :clearable="false"/>
          <el-button class="search-btn-blue" style="margin-left: 16px;" @click="getChartData" type="primary" size="mini">查询</el-button>
          <el-button class="search-btn-blue" style="margin-left: 20px;" @click="toExcel" type="primary" size="mini">导出</el-button>
        </el-row>
        <el-row style="background-color: #fff;width: 100%; height: 1px;"></el-row>
        <el-row style="overflow: hidden;height: calc(100% - 49px);width: 100%;" class="table">
          <el-table height="100%" width='100%' :data="tableData" ref="tableData" border fit>
            <el-table-column v-for="(item,i) in tableProps" :key="i"
                             :prop="item.prop" :label="item.label" :width="item.width">
              <el-table-column v-if='item.props' v-for="(prop,j) in item.props" :key="j"
                               :prop="prop.prop" :label="prop.label" :width="prop.width">
              </el-table-column>
            </el-table-column>
          </el-table>
        </el-row>
      </el-main>
    </el-row>
  </el-container>
</template>

<script>
import {Message} from "element-ui"
import DateUtils from "../../../utils/DateUtils"
import * as axios from "axios"
export default {
  name: "ParameterReport",
  data() {
    return {
      selNode: '',
      treeData: [],
      expandKeys: [],
      defaultProps: {
        children: 'childNode',
        label: 'name'
      },
      startDate: new Date().Format('yyyy-MM-dd'),
      tableProps: [
        {prop: "time", label: "时间段"},
        {prop: "sensorName", label: "测量点", width: '200px'},
        {prop: "minData", label: "电压", props: [{prop: "aVoltage", label: "A相(V)"}, {prop: "bVoltage", label: "B相(V)"},
          {prop: "cVoltage", label: "C相(V)"}]},
        {prop: "minData", label: "电流", props: [{prop: "aCurrent", label: "A相(A)"}, {prop: "bCurrent", label: "B相(A)"},
          {prop: "cCurrent", label: "C相(A)"}]},
        {prop: "minData", label: "功率因数", props: [{prop: "aPowFact", label: "A相"}, {prop: "bPowFact", label: "B相"},
          {prop: "cPowFact", label: "C相"}, {prop: "tPowFact", label: "总"}]},
        {prop: "minData", label: "有功功率", props: [{prop: "aPower", label: "A相(kW)"}, {prop: "bPower", label: "B相(kW)"},
          {prop: "cPower", label: "C相(kW)"}, {prop: "tPower", label: "总(kW)"}]},
        {prop: "minData", label: "无功功率", props: [{prop: "aValPower", label: "A相(kW)"}, {prop: "bValPower", label: "B相(kW)"},
          {prop: "cValPower", label: "C相(kW)"}, {prop: "tValPower", label: "总(kW)"}]},
        {prop: "minTime", label: "电能", props: [{prop: "activeEnergy", label: "正向有功电能(kWh)", width: '128px'},
          {prop: "reactiveEnergy", label: "反向有功电能(kWh)", width: '128px'}]}
      ],
      tableData: [],
      energyItem: [{'id': '1', 'name': '电'}],
      unit: 'kWh',
      media: '1'
    }
  },
  created() {
    this.getTree('1')
  },
  methods: {
    menuSelect(val) {
      this.tableData = []
      this.chartData = []
      this.media = val
      this.getTree(val)
      if (val === '1') {
        this.unit = 'kWh'
      } else {
        this.unit = 'm³'
      }
    },
    getTree(val) {
      this.$api.systemManage.getSensorTree(val).then(res => {
        this.treeData = res.data
        if (this.treeData && this.treeData.length > 0) {
          this.selNode = this.getLeafNode(this.treeData[0]);
          let nodeIdName = 'id';
          this.$nextTick(function () {
            this.setTreeCurrent(this.selNode[nodeIdName], 1);
          })
        }
      })
    },
    handleNodeClick(cNode, node) {
      this.selNode = cNode;
      if(node.data.type === '3') {
        this.getChartData()
      }
    },
    getLeafNode(pNode) {
      let leafNode = pNode;
      if (pNode.childNode && pNode.childNode.length > 0) {
        leafNode = this.getLeafNode(pNode.childNode[0]);
      }
      return leafNode;
    },
    handlePageChange(pageNo) {
      this.currPageNo = pageNo;
      this.getChartData();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.getChartData();
    },
    setTreeCurrent(key, time) {
      if (time > 10) throw new Error('没有找到 树组件');
      let tree = this.$refs.tree;
      if (tree) {
        tree.setCurrentKey(key);
        this.expandKeys.push(key);
        let node = tree.getNode(key);
        if (key !== -1) tree.$emit("node-click", node.data, node, tree);
      } else {
        this.setTreeCurrent(key, time + 1)
      }
    },
    getChartData() {
      if (this.selNode.type !== '3') {
        return
      }
      let params = {'id': this.selNode.id, 'dataDate': this.startDate}
      this.$api.energyReport.getParamForm(params).then(res => {
        this.tableData = res.data
      })
    },
    toExcel() {
      let param = []
      param.push(this.startDate)
      param.push(this.selNode.id);
      let paramStr;
      paramStr = '/energyReport/paramForm' + '/exportExcel?searchData=' + param.join('_');
      paramStr += '_' + sessionStorage.getItem('token');
      window.open(axios.defaults.baseURL + paramStr);
    }
  }
}

</script>

<style scoped>
  .doc-tree-top{
    display: inline-flex;
    align-items: center;
    height: 49px;
    width: 250px;
    border-bottom: 1px solid #fff;
  }
  /*.table /deep/ .el-table tr {*/
  /*  background-color: transparent!important;*/
  /*}*/
  .table /deep/ .el-table th {
    background-color: rgba(2, 124, 247, 0.2);
    border-top: 0;
  }
  /*.table /deep/ .el-table--enable-row-transition .el-table__body td, .el-table .cell{*/
  /*  background-color: transparent;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/components/EnergyEfficiency/FormManage/ParameterReport.vue